import React, { useState, useEffect } from 'react';
import CommonModalForm from '../../components/commonComponent/CommonModalForm';
import { validateForm } from '../../utils/formUtils';
import { toastSuccess, toastError } from '../../utils/alertHelper';
import axios from '../../utils/axiosInstance';
import { FaEdit, FaTrash } from 'react-icons/fa'; 

const PdfCategory = () => {
  const [pdfCategories, setPdfCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({ name: '' });
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

   const limit = parseInt(process.env.REACT_APP_PAGE_LIMIT || 10); 
  // const limit = 10;

  useEffect(() => {
    fetchPdfCategory(currentPage, searchQuery);
  }, [currentPage, searchQuery]);

  const fetchPdfCategory = async (page = 1, search = '') => {
    try {
      const res = await axios.get(`/admin/api/pdf-category?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
      const { pdfCategories = [], totalCount = 0 } = res.data;
      setPdfCategories(pdfCategories);
      setTotalPages(Math.ceil(totalCount / limit));
    } catch (err) {
      console.error('Failed to fetch PDF Category:', err);
    }
  };

  const handleSave = async () => {
    const validationErrors = validateForm(formValues, {
      name: { required: true },
    });

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      if (editingId) {
        await axios.put(`/admin/api/pdf-category/${editingId}`, formValues);
        toastSuccess('PDF Category updated successfully!');
      } else {
        await axios.post('/admin/api/pdf-category', formValues);
        toastSuccess('PDF Category added successfully!');
      }
      setCurrentPage(1);  // reset to first page after save
      fetchPdfCategory(1, searchQuery);
      handleCancel();
    } catch (err) {
      console.error('Failed to save PDF Category:', err);
      toastError('Failed to save PDF Category');
    }
  };

  const handleEdit = (pdfCategory) => {
    setFormValues({ name: pdfCategory.name });
    setEditingId(pdfCategory._id);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/admin/api/pdf-category/${id}`);
      toastSuccess('PDF Category deleted successfully!');
      setCurrentPage(1);  // reset to first page after delete
      fetchPdfCategory(1, searchQuery);
    } catch (err) {
      console.error('Failed to delete PDF Category:', err);
      toastError('Failed to delete PDF Category');
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setFormValues({ name: '' });
    setEditingId(null);
    setErrors({});
  };

  return (
    <div className="container mt-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0"> PDF Category</h3>
        <input
          type="text"
          className="form-control w-25"
          placeholder="Search PDF Category..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1); // reset page on search
          }}
        />
      </div>

      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="mb-0">PDF Category List</h5>
          <button
            className="btn btn-sm btn-success"
            onClick={() => setShowModal(true)}
          >
            + Add New PDF Category
          </button>
        </div>

        <div className="card-body p-0">
          <table
            className="table table-bordered table-sm mb-0"
            style={{ fontSize: '14px', lineHeight: '2' }}
          >
            <thead className="table-light">
              <tr>
                <th className="py-1 px-2 w-5">Sr no.</th>
                <th className="py-1 px-2 w-75">PDF Category</th>
                <th className="py-1 px-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {pdfCategories.length > 0 ? (
                pdfCategories.map((pdfCategory, idx) => (
                  <tr key={pdfCategory._id}>
                    <td className="py-1 px-2">{(currentPage - 1) * limit + idx + 1}</td>
                    <td className="py-1 px-2">{pdfCategory.name}</td>
                    <td className="py-1 px-2">
                      <button
                        className="btn btn-sm me-1 py-0 px-2 fs-6 lh-sm shadow-none border-0"
                        style={{
          
                          color: '#C44C23',
                    
                        }}
                        title="Edit"
                        onClick={() => handleEdit(pdfCategory)}
                      >
                        <FaEdit size={14} />
                      </button>
                      <button
                        className="btn btn-sm py-0 px-2"
                        style={{
                          fontSize: '12px',
                          lineHeight: '1.2',
                          boxShadow: 'none',
                          color: 'red',
                          border: 'none'
                        }}
                        onClick={() => handleDelete(pdfCategory._id)}
                        title="Delete"
                      >
                        <FaTrash size={14} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center py-2">No PDF Category found.</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-end align-items-center gap-2 p-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                &laquo;
              </button>

              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  className="btn btn-sm"
                  style={{
                    backgroundColor: currentPage === page ? '#C44C23' : 'transparent',
                    color: currentPage === page ? 'white' : '#C44C23',
                    border: '1px solid #C44C23'
                  }}
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ))}

              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                &raquo;
              </button>
            </div>
          )}
        </div>
      </div>
      
      <CommonModalForm
        visible={showModal}
        title={editingId ? 'Edit PDF Category' : 'Add PDF Category'}
         fields={[
              { name: 'name', label: 'PDF Category', placeholder: 'Enter PDF Category Name' }
            ]}
        values={formValues}
        errors={errors}
        onChange={setFormValues}
        onSubmit={handleSave}
        onCancel={handleCancel}
        submitLabel={editingId ? 'Update' : 'Save'}
        requiredFields={['name']}
      />
    </div>
  );
};

export default PdfCategory;
